import React, {Fragment, FunctionComponent, useEffect, useState} from "react";
import {FunnelHeader} from "@App/Components/Funnel/FunnelHeader";
import {Input} from "@App/Components/common/Input";
import {useTranslation} from "react-i18next";
import {PhoneInput} from "@App/Components/common/PhoneInput";
import {Checkbox} from "@App/Components/common/Checkbox";
import {useCreateEstimation} from "@App/hooks/api/mutations/useCreateEstimation";
import {useDispatch, useSelector} from "react-redux";
import {actionCreators, State} from "@App/state"
import {bindActionCreators} from "@reduxjs/toolkit";
import {Loader} from "@App/Components/Loader";


type SubmitProps = {
    headline: string
    subheadline?: string
    description?: string
    step: number
    maxSteps: number
    onSubmit?: () => void
}

export const Submit: FunctionComponent<SubmitProps> = ({
                                                           headline,
                                                           subheadline,
                                                           description,
                                                           step,
                                                           maxSteps,
                                                           onSubmit
                                                       }: SubmitProps) => {
    const {t} = useTranslation()

    const service = useSelector((state: State) => state.orders.service)
    const email = useSelector((state: State) => state.orders.email)
    const phone = useSelector((state: State) => state.orders.phone)

    const dispatch = useDispatch();
    const {setEmail} = bindActionCreators(actionCreators, dispatch)
    const {setPhone} = bindActionCreators(actionCreators, dispatch)

    const [tos, setTos] = useState(false)
    const [marketing, setMarketing] = useState(false)

    const {
        error,
        loading,
        estimation,
        validationErrors,
        submit
    } = useCreateEstimation({email, phone, tos, marketing})

    useEffect(() => {
        if (estimation && estimation.id) {
            onSubmit()
        }
    }, [estimation])

    if (loading || !service) {
        return <div className="grid place-items-center">
            <Loader/>
        </div>
    }

    return (
        <Fragment>
            <div className="
                    container bg-white
                    pt-10 pb-12
                ">
                <FunnelHeader heading={headline}
                              step={step}
                              maxSteps={maxSteps}
                              subheading={subheadline ? subheadline : t('submit.headline')}
                />
                <div className="flex flex-col md:flex-row">
                    <div className="w-full md:w-5/12 pr-4">
                        <Input
                            id="email"
                            type="email"
                            name="email"
                            className="w-full"
                            placeholder={t('submit.email')}
                            required
                            onChange={setEmail}
                            value={email}
                            validationMessage={validationErrors.email ? t('contactForm.validationErrors.email') : null}
                        />
                        <PhoneInput
                            id="phone"
                            type="tel"
                            name="phone"
                            className="w-full"
                            placeholder={t('submit.phone')}
                            onChange={setPhone}
                            value={phone}
                        />
                        <p className={`
                                    text-sm
                                    text-neutral-500
                                    italic
                        `}>Rufnummer angeben und exklusive Rabatte erhalten.</p>
                        <div className="flex mt-4">
                            <Checkbox id={"legal"} status={tos} onChange={setTos}/>
                            <label htmlFor={"legal"}>
                                Ich stimme den <a
                                href="https://www.repareo.de/allgemeine-nutzungsbedingungen-fuer-repareo/"
                                target="_blank">Nutzungsbedingungen</a> und
                                der <a
                                href="https://www.repareo.de/datenschutzerklaerung/"
                                target="_blank">Datenschutzerklärung</a> zu.
                                Widerruf jederzeit möglich
                            </label>
                        </div>
                        {validationErrors.tos && (
                            <div className={'mb-3 text-sm text-error'}>
                                {t('contactForm.validationErrors.tos')}
                            </div>
                        )}
                        <div className="flex mt-3">
                            <Checkbox id={"marketing"} status={marketing} onChange={setMarketing}/>
                            <label htmlFor={"marketing"}>
                                Ich möchte für exklusive Sonderkonditionen & Rabatte kontaktiert werden.
                            </label>
                        </div>

                        <button
                            className={`
                                    w-full max-w-full
                                    bg-primary rounded
                                    mt-5 py-3 px-5
                                    text-center text-white font-serif
                                    cursor-pointer
                                    disabled:opacity-25
                                    disabled:cursor-not-allowed
                                `}
                            // disabled={disabled}
                            dangerouslySetInnerHTML={{__html: t('submit.button')}}
                            onClick={(e) => submit(e)}>
                        </button>
                    </div>
                    <div className="w-full md:w-7/12 pl-12 py-8">
                        <div className="flex">
                            <ul className="p-0 mt-4 list-none">
                                <li className="text-success mb-4">
                                    <div className="flex items-center">
                                        <img className="mr-4 w-5 h-5"
                                             src="/images/icons/icon-checkmark-green.svg" alt=""/>
                                        <div className="font-bold">
                                            {t('submit.benefit-1')}
                                        </div>
                                    </div>
                                </li>
                                <li className="text-success mb-4">
                                    <div className="flex items-center">
                                        <img className="mr-4 w-5 h-5"
                                             src="/images/icons/icon-checkmark-green.svg" alt=""/>
                                        <div className="font-bold">
                                            {t('submit.benefit-2')}
                                        </div>
                                    </div>
                                </li>
                                <li className="text-success mb-4">
                                    <div className="flex items-center">
                                        <img className="mr-4 w-5 h-5"
                                             src="/images/icons/icon-checkmark-green.svg" alt=""/>
                                        <div className="font-bold">
                                            {t('submit.benefit-3')}
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
